<template>
    <router-view />
</template>

<script>

    export default {
        name: 'App',

        /* <<< ****************************************************************/

        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;

		}, // eo function created()
		/* <<< ****************************************************************/
        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {}, // eo function destroyed()
        /* <<< ****************************************************************/

        /* >>> *************************************************************** / /* Methods */
		methods: {} // eo function methods()

    };

</script>

<style lang="scss">
    @import './App.scss';

    .toast_custom-font-error {
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: 400 !important;
        background-color: #eb445a !important;
    }

    .toast_custom-font-info {
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: 400 !important;
        background-color: #1e96fc !important;
    }

</style>
